import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {Link} from 'gatsby';


function Readybuild(props) {
    return (
        <section className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="AZURE Optimize">
                            <h2>Deploy Microsoft Azure To Get A Definite Edge Over The Competition</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p> TekRevol has enabled clients from diverse industries to harness the power of data to achieve
                            their business objectives faster. Here is what we have helped them with:</p>
                        <p>Building flexible and broader data ecosystems with on-point Azure consulting
                            Managing real-time and remote access to data from different end-points
                            Developing mission-critical application backends
                            Experience higher returns on technical development after cloud migration</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Readybuild;